import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import { Typography, TextareaAutosize, Divider } from "@mui/material";
import styled from "styled-components";
import { Box } from "@mui/system";
import MuiTab from "./Tab/MuiTab";
import CommentsBox from "./comments/CommentsBox";
import useToaster from "../customHook/useToaster";

const tabs = [{ label: "View Comment" }, { label: "Add New Comment" }];

const ThemedTextareaAutosize = styled(TextareaAutosize)(
  ({ theme }) => `
  resize: none;
width: 100%;
padding: 0.6rem;
borderRadius: 4px;
border: 1px solid #E8E8E8;
fontFamily: inter;
fontSize: 1.4rem;
lineHeight: 1.5;`
);

const CommonDescription = ({
  minRows = 9,
  isHeadingHidden = false,
  heading = "Description",
  placeholder = "Enter Description",
  isSubmitActive = true,
  onSubmitButton = () => {},
  onChange = () => {},
  descriptionVal,
  descriptionRef,
  isButtonHidden = false,
  maxLength,
  disabled = false,
  bgcolor = "#fff",
  isTabView = false,
  tabData = [],
}) => {
  const [currentValue, setCurrentValue] = useState(0);
  const [activeTab, setActiveTab] = useState(0);
  const { showToast } = useToaster();
  const tabClickHandler = (e, newValue) => {
    setActiveTab(newValue);
  };
  const onSubmitButtonHandler = (e) => {
    onSubmitButton(e);
    setCurrentValue(0);
  };
  useEffect(() => {
    if (descriptionVal) {
      setCurrentValue(descriptionVal?.length || 0);
    }
  }, []);

  useEffect(() => {
    if (tabs[activeTab]?.label === "Add New Comment") {
      document.getElementById("case-desc-input")?.focus();
    }
  }, [activeTab]);
  return (
    <Box
      sx={
        isTabView
          ? {
              boxShadow: "0px 2px 4px 4px #A39D9933",
              marginTop: "1.3rem",
              padding: "12px",
              borderRadius: "12px",
            }
          : { marginTop: "1.5rem" }
      }
    >
      <Typography
        sx={{
          marginBottom: "1.2rem",
          color: "#000000",
          fontSize: "1.3rem",
          padding: "-0.1rem -0.1rem",
          display: isHeadingHidden ? "none" : "block",
          fontWeight: 600,
        }}
      >
        {heading}
      </Typography>

      {isTabView && (
        <MuiTab
          tabs={tabs}
          variant="standard"
          fontSize="12px"
          standardMinContent={true}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          onClick={tabClickHandler}
        />
      )}
      {isTabView && <Box sx={{ p: 1.5 }}></Box>}
      {tabs[activeTab]?.label === "View Comment" && isTabView && (
        <CommentsBox sidebarTable={true} data={tabData} />
      )}

      {(tabs[activeTab]?.label === "Add New Comment" || !isTabView) && (
        <Box>
          <ThemedTextareaAutosize
            disabled={disabled}
            minRows={minRows}
            placeholder={placeholder}
            size="lg"
            id="case-desc-input"
            value={descriptionVal}
            ref={descriptionRef}
            onKeyDown={(e) => {
              const allowed = /^[a-zA-Z0-9\s.,!?'\-]$/;
              if (
                e.key.length === 1 && // filters out control keys like "Backspace", "Enter"
                !allowed.test(e.key)
              ) {
                e.preventDefault();
                showToast(
                  "Special characters are not allowed",
                  "warning",
                  true
                );
              }
            }}
            onChange={(e) => {
              onChange(e);
              setCurrentValue(e?.target?.value?.trim()?.length);
            }}
            maxLength={maxLength}
            style={{
              backgroundColor: bgcolor,
            }}
          />
          {maxLength && (
            <div
              style={{
                textAlign: "end",
                fontSize: "1.2rem",
              }}
            >
              {currentValue + "/" + maxLength}
            </div>
          )}

          {!isButtonHidden && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "1.7rem",
                marginBottom: "1.7rem",
              }}
            >
              <Button
                variant="contained"
                sx={{
                  ":hover": {
                    bgcolor:
                      currentValue > 0 ? "#e85055" : "rgba(232, 80, 91, 0.3)",
                    color: currentValue > 0 ? "white" : "#E8505B",
                    boxShadow: "4px 4px 3px rgba(0, 0, 0, 0.25)",
                  },
                  width: "max-content",
                  textTransform: "none",
                  display: "flex",
                  backgroundColor:
                    currentValue > 0 ? "#e85055" : "rgba(232, 80, 91, 0.3)",
                  // backgroundColor: "#e85055",
                  fontSize: "1.2rem",
                  padding: "0.8rem 2.7rem",
                  boxShadow: "4px 4px 3px rgba(0, 0, 0, 0.25)",
                  color: currentValue > 0 ? "white" : "#E8505B",
                  // color: "white",
                  // pointerEvents: !isSubmitActive ? "none" : "inherit",=
                }}
                onClick={
                  currentValue > 0
                    ? onSubmitButtonHandler
                    : () => showToast("Please fill description", "info", true)
                }
              >
                Submit
              </Button>
            </div>
          )}
        </Box>
      )}
    </Box>
  );
};

export default CommonDescription;
